var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEnter = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 27 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.167 5.333 10.3 7.2l3.467 3.467H.167v2.666h13.6L10.3 16.8l1.867 1.867L18.833 12l-6.666-6.667Zm12 16H13.5V24h10.667c1.466 0 2.666-1.2 2.666-2.667V2.667C26.833 1.2 25.633 0 24.167 0H13.5v2.667h10.667v18.666Z"
  })));
};
export { SvgEnter as ReactComponent };